import { client } from "api";
import { Checklist } from "models/Checklist";

export type ExcludeChecklistRequest = { checklistId: string; excludedFromReport: boolean };
export type ExcludeChecklistResponse = Checklist;

export const excludeChecklist = ({ checklistId, excludedFromReport }: ExcludeChecklistRequest) =>
  client
    .patch<ExcludeChecklistResponse>(`/checklist/set-excluded-from-report/${checklistId}`, {
      excludedFromReport,
    })
    .then((res) => res.data);
